export default function MvpPagamento() {
  return (
    <section id="pagamento" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-[#071210] flex items-center justify-center">
            <span className="text-emerald-400 text-xs font-bold">IV</span>
          </div>
          <span className="text-stone-400 text-xs uppercase tracking-widest font-medium">Parte IV</span>
        </div>
        <h2 className="text-3xl font-bold text-stone-900 mb-2">Forma de Pagamento — Fase 1</h2>
        <p className="text-stone-500 mb-8 text-base">Investimento total de R$ 357.000 dividido em 3 parcelas vinculadas a marcos de entrega.</p>

        {/* Estrutura */}
        <div className="flex flex-wrap gap-3 mb-10">
          {[
            { pct: '50%', valor: 'R$ 178.500', label: 'No início do projeto', desc: 'Na assinatura do contrato — Dia 0', color: 'bg-emerald-50 border-emerald-200 text-emerald-700' },
            { pct: '20%', valor: 'R$ 71.400', label: 'No meio do projeto', desc: 'Na entrega dos módulos 1 a 4 — Dia 60', color: 'bg-amber-50 border-amber-200 text-amber-700' },
            { pct: '30%', valor: 'R$ 107.100', label: 'Na entrega final', desc: 'No go-live e aceite final — Dia 120', color: 'bg-stone-100 border-stone-300 text-stone-700' },
          ].map((s) => (
            <div key={s.pct} className={`flex-1 min-w-[180px] p-5 rounded-xl border ${s.color}`}>
              <p className={`text-3xl font-bold mb-0.5 ${s.color.split(' ')[2]}`}>{s.pct}</p>
              <p className="text-stone-900 font-bold text-base mb-1">{s.valor}</p>
              <p className="text-xs font-semibold text-stone-700">{s.label}</p>
              <p className="text-xs text-stone-400 mt-0.5">{s.desc}</p>
            </div>
          ))}
        </div>

        {/* Detalhamento das parcelas */}
        <div className="rounded-2xl border border-stone-200 overflow-hidden mb-10">
          <div className="bg-stone-900 px-5 py-4 flex items-center justify-between">
            <span className="text-white font-semibold">Fase 1 — Versão 1</span>
            <span className="text-emerald-400 font-bold text-lg">R$ 357.000</span>
          </div>
          <div className="divide-y divide-stone-100 bg-white">
            {[
              { marco: 'Assinatura do contrato', quando: 'Dia 0', pct: '50%', valor: 'R$ 178.500', badge: 'bg-emerald-100 text-emerald-700' },
              { marco: 'Entrega dos Módulos 1 a 4 (monitoramento, análise, matching e dashboard)', quando: 'Dia 60', pct: '20%', valor: 'R$ 71.400', badge: 'bg-amber-100 text-amber-700' },
              { marco: 'Go-live completo, testes finais, treinamento e aceite da Versão 1', quando: 'Dia 120', pct: '30%', valor: 'R$ 107.100', badge: 'bg-stone-100 text-stone-600' },
            ].map((par, j) => (
              <div key={j} className="px-5 py-4">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1">
                    <div className={`inline-block px-2 py-0.5 rounded-full text-xs font-bold mb-1.5 ${par.badge}`}>{par.pct}</div>
                    <p className="text-stone-700 text-sm font-medium leading-snug">{par.marco}</p>
                    <p className="text-stone-400 text-xs mt-0.5">{par.quando}</p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <p className="text-stone-900 text-base font-bold">{par.valor}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Manutenção */}
        <div className="p-6 rounded-2xl border border-stone-200 bg-stone-50">
          <h3 className="text-base font-semibold text-stone-800 mb-2">Manutenção Contínua (a partir da entrega da Fase 1)</h3>
          <p className="text-stone-400 text-sm mb-5">Após o go-live da Versão 1, a plataforma entra em regime de manutenção mensal que cobre todos os módulos entregues.</p>
          <div className="p-5 rounded-xl border border-emerald-200 bg-white">
            <div className="flex items-center justify-between mb-3">
              <p className="text-stone-700 font-semibold text-base">Manutenção Fase 1</p>
              <p className="text-stone-900 font-bold text-xl">R$ 12.000/mês</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {[
                'Correções de bugs e ajustes de comportamento dos agentes de IA',
                'Atualizações de segurança e patches de infraestrutura',
                'Monitoramento proativo da plataforma com alertas de falha',
                'Suporte técnico por canal dedicado com SLA de 24h úteis',
                'Atualização da base de conhecimento com novos documentos FINEP',
                'Relatório mensal de uso, performance e saúde da plataforma',
                'Ajustes de prompts e calibração dos agentes conforme novos editais',
                'Acompanhamento de mudanças nas regras e formulários da plataforma FINEP',
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-2">
                  <div className="w-3 h-3 mt-0.5 flex items-center justify-center flex-shrink-0">
                    <div className="w-1.5 h-1.5 rounded-full bg-emerald-500"></div>
                  </div>
                  <span className="text-stone-500 text-xs leading-relaxed">{item}</span>
                </div>
              ))}
            </div>
          </div>
          <p className="text-stone-400 text-xs mt-4 italic">Manutenção não inclui novas funcionalidades, que são orçadas separadamente mediante escopo definido.</p>
        </div>
      </div>
    </section>
  );
}
